import { render, staticRenderFns } from "./MatResults.vue?vue&type=template&id=683114fa&scoped=true"
import script from "./MatResults.vue?vue&type=script&lang=js"
export * from "./MatResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683114fa",
  null
  
)

export default component.exports